import React from 'react';
import PropTypes from 'prop-types';
import FeatureCard from './Card';

const FeaturesGrid = ({ header, features }) => {
  return (
    <div className="bg-[#F8F9FB] text-center lg:text-left px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-12 w-full">
      <h2 className="text-4xl font-bold text-center mb-10">{header}</h2>
      <div className="flex flex-col gap-11 lg:flex-row justify-between items-center max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feature, index) => (
            <FeatureCard key={index} imageSrc={feature.image} title={feature.title} description={feature.description} />
          ))}
        </div>
      </div>
    </div>
  );
};

FeaturesGrid.propTypes = {
  header: PropTypes.string,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
    })
  ),
};

export default FeaturesGrid;
